import React from 'react';

import { Container } from './styles';
import modal from './Modal';
import { IModalMessage } from '../../index';


interface IModalContainerProps {
  messages: IModalMessage[];
  className: string;
  closeButton: boolean;
}

const ModalContainer: React.FC<IModalContainerProps> = ({ messages, className, closeButton = true }) => {
  return (<>

    {messages.map(item => <Container>
      {modal({ key: item.id, title: item.title, content: item.content, className, closeButton, theme: item?.theme || '' })}
    </Container>
    )}
  </>
  );
};

export default ModalContainer;
